<doc-ngb-dialog
  [(visible)]="showEmptyFolderDialog"
  [modal]="true"
  [draggable]="false"
  [closable]="false"
  [style]="{width: '350px'}"
  appendTo="body"
  [baseZIndex]="200220"
  styleClass="empty-folder-warning-dialog">
  <ng-template #dialogHeader>
    <h3 class="m-0">Empty Folder</h3>
  </ng-template>
  <div class="d-flex align-items-center justify-content-center text-center py-2">
    The selected folder is empty. Please choose a folder that contains at least one file.
  </div>
  <ng-template #dialogFooter>
    <div class="d-flex justify-content-center w-100">
      <button type="button" class="reject-btn w-100" (click)="showEmptyFolderDialog = false">
        Close
      </button>
    </div>
  </ng-template>
</doc-ngb-dialog>

<doc-ngb-dialog [modal]="true" [(visible)]="visible" [style]="{ width: '60rem', maxWidth: 'calc(100vw - 1.5rem)' }"
  [closable]="false" [draggable]="false"
  appendTo="body" [baseZIndex]="200000" styleClass="scrollable-modal-dialog upload-media-dialog">
  <ng-template #dialogHeader>
    <div class="upload-dialog-header">
      <div class="upload-dialog-header-left">
        <span class="upload-dialog-header-icon" aria-hidden="true">
          <i class="pi pi-cloud-upload"></i>
        </span>
        @if (editMode) {
          <div class="p-dialog-title upload-dialog-title">
            @if (folderMetadataEditMode) {
              <span class="upload-dialog-title-prefix">Edit Folder Metadata :</span>
              <strong class="upload-dialog-title-name" [attr.title]="folderMetadataName || 'Folder'">
                {{ folderMetadataName || 'Folder' }}
              </strong>
            } @else {
              Edit File Metadata
            }
          </div>
        }
        @if (!editMode) {
          <div class="p-dialog-title upload-dialog-title">{{ 'MEDIALIBRARY.uploadDialogTitle' | translate }}</div>
        }
      </div>
      <button type="button" class="upload-dialog-close-btn"
      (click)="closeDialog()" aria-label="Close"><i class="pi pi-times"></i></button>
    </div>
  </ng-template>

  <!-- Drag & Drop Area -->
  @if (!editMode) {
    <div class="drop-zone" [class.dragging]="isDragging" (dragenter)="onDragEnter($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      <div class="drop-zone-content">
        <div class="drop-zone-layout">
          <div class="drop-actions">
            <div class="browse-trigger-wrapper">
              <div class="browse-options-panel">
                <button
                  type="button"
                  class="browse-option-tile"
                  [class.is-active]="activeBrowseMode === 'file'"
                  (click)="browseFiles(fileInput)">
                  <i class="pi pi-file browse-option-icon"></i>
                  <span class="browse-option-title">{{ 'MEDIALIBRARY.uploadSelectFiles' | translate }}</span>
                  <span class="browse-option-sub">{{ 'MEDIALIBRARY.uploadSelectFilesHint' | translate }}</span>
                </button>
                @if (showFolderUploadOption && IS_FOLDER_UPLOAD_ENABLED) {
                  <button
                    type="button"
                    class="browse-option-tile"
                    [class.is-active]="activeBrowseMode === 'folder'"
                    (click)="browseFolder(folderInput)">
                    <i class="pi pi-folder browse-option-icon"></i>
                    <span class="browse-option-title">{{ 'MEDIALIBRARY.uploadSelectFolder' | translate }}</span>
                    <span class="browse-option-sub">{{ 'MEDIALIBRARY.uploadSelectFolderHint' | translate }}</span>
                  </button>
                }
              </div>
              <input #fileInput type="file" (change)="onFileSelect($event)" multiple hidden [accept]="UPLOAD_ACCEPT_ATTR">
              <input #folderInput type="file" (change)="onFolderSelect($event)" webkitdirectory directory multiple hidden [accept]="UPLOAD_ACCEPT_ATTR">
            </div>
            <p class="drop-zone-text">{{ 'MEDIALIBRARY.uploadDragDrop' | translate }}</p>
            <p class="allowed-types-text">
              {{ 'MEDIALIBRARY.uploadAllowedTypes' | translate }}
              <span class="allowed-types-list">{{ ALLOWED_UPLOAD_EXTENSIONS_LABEL }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  }

    <!-- Selected Items List -->
    @if (!editMode && uploadItemsForDisplay.length > 0) {
      <div class="selected-files-container mb-3">
        @for (item of uploadItemsForDisplay; track trackByUploadItem($index, item)) {
          <div class="selected-file-item">
            <div class="selected-file-leading">
              <span class="selected-file-type-icon" aria-hidden="true">
                <i class="pi" [ngClass]="item.type === 'folder' ? 'pi-folder' : 'pi-file'"></i>
              </span>
              <div class="selected-file-content">
                <div class="selected-file-name-row">
                  @if (isUploadItemRenaming(item)) {
                    <input
                      #uploadItemRenameInput
                      type="text"
                      class="name-edit-input"
                      [(ngModel)]="renameDrafts[item.key]"
                      (keyup.enter)="saveUploadItemRename(item)"
                      (blur)="saveUploadItemRename(item)"
                      [placeholder]="item.type === 'folder' ? 'Folder name' : 'File name'"
                      />
                    } @else {
                      <span class="item-name-text" [attr.title]="item.displayName">{{ item.displayName }}</span>
                      <button
                        type="button"
                        class="rename-icon-btn"
                        (click)="startUploadItemRename(item)"
                        [title]="item.type === 'folder' ? 'Rename folder' : 'Rename file'">
                        <i class="pi pi-pencil"></i>
                      </button>
                    }
                  </div>
                  <span class="status-badge" [ngClass]="'status-' + item.status">
                    {{ item.statusLabel }}
                  </span>
                </div>
              </div>
            <div class="selected-file-trailing">
              <span class="file-size-text">{{ formatBytes(item.totalSize) }}</span>
              <button
                type="button"
                class="remove-upload-item-btn"
                (click)="removeUploadItem(item)"
                title="Remove item"
                aria-label="Remove item">
                <i class="pi pi-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        }
        </div>
      }

      @if (showFolderSelectionInFileUpload) {
        <!-- dma-ai: when editing an existing file, show its AI state (or the
             send action). resolveAiJob() fills aiJobId when the file loads. -->
        <div class="form-group full-width ai-edit-status" *ngIf="aiEnabled && fileId && fileId > 0">
          <label class="form-label">{{ 'ai.review.title' | translate }}</label>
          <button
            *ngIf="!aiJobId"
            type="button"
            class="ds-btn ds-btn--solid ds-btn--sm ai-send-btn"
            [disabled]="aiSending"
            (click)="sendForAi()">
            <i class="pi pi-sparkles" aria-hidden="true"></i>
            {{ (aiSending ? 'ai.send.sending' : 'ai.send.action') | translate }}
          </button>
          <button
            *ngIf="aiJobId"
            type="button"
            class="status-badge"
            [ngClass]="aiJobStage === 'completed' ? 'status-active' : aiJobStage === 'failed' ? 'status-inactive' : aiJobStage === 'processing' ? 'status-processing' : 'status-pending'"
            (click)="openAiResults()">
            {{ ('ai.status.' + (aiJobStage ?? 'queued')) | translate }}
          </button>
        </div>

        <div class="form-group full-width">
          <label class="form-label">{{ 'MEDIALIBRARY.uploadSelectAFolder' | translate }} <span class="text-danger">*</span></label>
          <div class="folder-title-box" [class.expanded]="isFolderTreeVisible" (click)="toggleFolderTree()">
            <span
              class="folder-title-text"
              [class.text-muted]="needsDepartmentFolderSelectionInPicker"
              [title]="displayFolderSelectionLabel">
              {{ displayFolderSelectionLabel }}
            </span>
            @if (showClearFolderSelection) {
              <button
                type="button"
                class="folder-selection-clear"
                (click)="clearFolderSelection($event)"
                [attr.aria-label]="'MEDIALIBRARY.uploadClearFolderSelection' | translate"
                [title]="'MEDIALIBRARY.uploadClearFolderSelection' | translate">
                <i class="pi pi-times"></i>
              </button>
            }
            <div class="folder-title-icon">
              <i class="pi" [ngClass]="isFolderTreeVisible ? 'pi-folder-open' : 'pi-folder'" aria-hidden="true"></i>
            </div>
          </div>
          <!-- Accordion Tree Content -->
          @if (isFolderTreeVisible) {
            <div class="folder-browser-container animate-fade-in">
              @if (showDepartmentDropdownForPicker) {
                <div class="p-3 border-bottom bg-white">
                  <label class="form-label small mb-1">{{ 'DocumentPage.Department' | translate }} <span class="text-danger">*</span></label>
                  <div class="select-wrapper ng-select-wrapper">
                    <ng-select
                      [items]="departments"
                      [(ngModel)]="pickerFilterDepartmentId"
                      bindLabel="label"
                      bindValue="value"
                      [placeholder]="'MEDIALIBRARY.uploadSelectDepartmentToBrowse' | translate"
                      [searchable]="true"
                      [clearable]="true"
                      class="field-control ng-select-field"
                      appendTo="body"
                      (change)="onPickerFilterDepartmentChange()">
                    </ng-select>
                  </div>
                </div>
              }
              <div class="folder-search-box">
                <div class="folder-search-field">
                  <i class="pi pi-search"></i>
                  <input
                    type="text"
                    [placeholder]="'MEDIALIBRARY.uploadSearchFolderPlaceholder' | translate"
                    [(ngModel)]="folderSearchTerm"
                    (ngModelChange)="onFolderSearchInput($event)"
                    />
                  @if (folderSearchTerm) {
                    <button
                      type="button"
                      class="folder-search-clear"
                      (click)="onFolderSearchInput('')"
                      [attr.aria-label]="'MEDIALIBRARY.uploadClearFolderSearch' | translate">
                      <i class="pi pi-times"></i>
                    </button>
                  }
                </div>
              </div>
                <div class="tree-container">
                  <div class="tree-content-wrapper">
                    @if (showFolderTreeLoadingState) {
                      <div class="folder-tree-status-state">
                        <i class="pi pi-spin pi-spinner"></i>
                        <span>{{ 'MEDIALIBRARY.uploadLoadingFolders' | translate }}</span>
                      </div>
                    }
                    @if (showFolderTreeEmptyState) {
                      <div class="folder-tree-status-state">
                        <i class="pi pi-folder-open"></i>
                        <span>{{ folderTreeEmptyMessage }}</span>
                      </div>
                    }
                    @if (!showFolderTreeEmptyState && !showFolderTreeLoadingState) {
                      <doc-tree
                        [value]="activeFolderNodes"
                        selectionMode="single"
                        [(selection)]="selectedNode"
                        (onNodeSelect)="onNodeSelect($event)"
                        [loading]="isLoadingFolders"
                        emptyMessage=""
                        styleClass="custom-folder-tree">
                        <ng-template docTreeNode let-node>
                          <div class="tree-node-content d-flex align-items-center gap-2 flex-grow-1 min-w-0">
                            <i
                              class="pi tree-node-folder-icon"
                              [ngClass]="node.expanded ? 'pi-folder-open' : 'pi-folder'"
                              aria-hidden="true"></i>
                              @if (showPickerFolderRenameInput(node)) {
                                <div class="picker-folder-rename-editor">
                                  <div class="picker-folder-rename-main">
                                    <input
                                      #pickerFolderRenameInput
                                     
                                      type="text"
                                      class="picker-folder-rename-input flex-grow-1 min-w-0"
                                      [(ngModel)]="folderRenameDraft"
                                      (click)="$event.stopPropagation()"
                                      (keydown.enter)="$event.preventDefault(); commitPickerFolderRename()"
                                      (keydown.escape)="$event.preventDefault(); cancelPickerFolderRename()"
                                      [maxlength]="folderNameMaxLength"
                                      [title]="'Press Enter to save'">
                                      <div class="picker-folder-rename-actions">
                                        <span class="picker-folder-rename-counter">
                                          {{ (folderRenameDraft || '').length }}/{{ folderNameMaxLength }}
                                        </span>
                                        <button
                                          type="button"
                                          class="rename-action-btn save"
                                          (click)="$event.stopPropagation(); commitPickerFolderRename()"
                                          title="Save folder name"
                                          aria-label="Save folder name">
                                          <i class="pi pi-check"></i>
                                        </button>
                                        <button
                                          type="button"
                                          class="rename-action-btn cancel"
                                          (click)="$event.stopPropagation(); cancelPickerFolderRename()"
                                          title="Cancel rename"
                                          aria-label="Cancel rename">
                                          <i class="pi pi-times"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                }
                                @if (!showPickerFolderRenameInput(node)) {
                                  <span class="tree-node-label" [title]="node.label">
                                    {{ node.label?.length > 50 ? (node.label | slice:0:50) + '...' : node.label }}
                                  </span>
                                }
                                @if (!showPickerFolderRenameInput(node) && canRenameFolderNode(node)) {
                                  <button
                                    type="button"
                                    class="tree-node-rename-trigger"
                                    (click)="startPickerFolderRename(node, $event)"
                                    title="Rename folder"
                                    aria-label="Rename folder">
                                    <i class="pi pi-pencil"></i>
                                  </button>
                                }
                              </div>
                            </ng-template>
                          </doc-tree>
                        }
                      </div>
                    </div>
                    <div class="tree-actions">
                      <button
                        type="button"
                        class="custom-outline-btn text-sm font-semibold"
                        (click)="openNewFolderDialog(); $event.stopPropagation()"
                        [disabled]="isCreatingFolder || needsDepartmentFolderSelectionInPicker">
                        <i class="pi pi-folder-plus"></i>
                        {{ 'MEDIALIBRARY.uploadCreateFolder' | translate }}
                      </button>
                      <button
                        type="button"
                        class="custom-solid-btn text-sm font-semibold"
                        (click)="onFolderTreeSelectButtonClick($event)"
                        [disabled]="!selectedNode || departmentTreeBlockedBySelection || needsDepartmentFolderSelectionInPicker">
                        <i class="pi pi-check"></i>
                        {{ 'MEDIALIBRARY.uploadFolderSelect' | translate }}
                      </button>
                    </div>
                  </div>
                }
              </div>
            }

            <!-- Form Fields -->
            <div class="form-grid form-grid--media-fields mt-4">

              <!-- Row 1: Title and Event (User moved Title here) -->
              <!-- <div class="form-group">
              <label class="form-label">Title <span class="text-danger">*</span></label>
              <input type="text" placeholder="Title" [(ngModel)]="title" required #titleInput="ngModel" (keyup)="onTitleInput($event)" [readonly]="resumeMetadataLocked" maxlength="150">
              <small class="text-muted text-base">{{ title?.length || 0 }}/150 characters</small>
              <small class="text-danger text-base d-block" *ngIf="titleInput.invalid && titleInput.touched">
                Title is required
              </small>
            </div> -->

            @if (editMode && !folderMetadataEditMode) {
              @if (resubmitWorkflowOnUpdate && returnComment) {
                <div class="return-comment-banner full-width">
                  <strong>{{ 'DocumentPage.Return' | translate }} {{ 'TASKS.Comment' | translate }}</strong>
                  <p>{{ returnComment }}</p>
                </div>
              }

              <div class="form-group full-width">
                <label class="form-label">File Name <span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="field-control"
                  placeholder="File Name"
                  [(ngModel)]="editedFileName"
                  maxlength="255"
                  />
                </div>

                @if (resubmitWorkflowOnUpdate) {
                  <div class="form-group full-width">
                    <label class="form-label">
                      {{ 'TASKS.Comment' | translate }} <span class="text-danger">*</span>
                    </label>
                    <textarea
                      class="field-control field-textarea"
                      [(ngModel)]="resubmitComment"
                      [placeholder]="'TASKS.CommentPlaceholder' | translate"></textarea>
                    @if (!resubmitComment.trim()) {
                      <small class="text-danger text-base">{{ 'TASKS.CommentRequired' | translate }}</small>
                    }
                  </div>
                }
              }

              @if (!folderMetadataEditMode) {
                <div class="form-group">
                  <label class="form-label">{{ 'DocumentPage.DocumentType' | translate }}</label>
                  <div class="select-wrapper">
                    <select
                      class="field-control"
                      [(ngModel)]="documentTypeId"
                      [disabled]="resumeMetadataLocked">
                      <option [ngValue]="''">{{ 'DocumentPage.SelectDocumentType' | translate }}</option>
                      @for (option of documentTypeOptions; track option.value) {
                        <option [ngValue]="option.value">{{ option.label }}</option>
                      }
                    </select>
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-label">{{ 'DocumentPage.Department' | translate }}</label>
                  <div class="select-wrapper">
                    <select
                      class="field-control"
                      [(ngModel)]="selectedUploadDepartmentId"
                      (ngModelChange)="onUploadDepartmentChange()"
                      [disabled]="resumeMetadataLocked || editMode">
                      <option [ngValue]="null">{{ 'DocumentPage.SelectDepartment' | translate }}</option>
                      @for (dept of departments; track dept.value) {
                        <option [ngValue]="dept.value">{{ dept.label }}</option>
                      }
                    </select>
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-label">
                    {{ 'DocumentPage.Category' | translate }} <!-- <span class="text-danger">*</span> -->
                  </label>
                  <div class="select-wrapper">
                    <select
                      class="field-control"
                      [(ngModel)]="selectedCategoryId"
                      (ngModelChange)="onUploadCategoryChange()"
                      [disabled]="isCategoryLocked || editMode">
                      <option [ngValue]="null">{{ 'DocumentPage.SelectCategory' | translate }}</option>
                      @for (cat of uploadCategories; track cat.value) {
                        <option [ngValue]="cat.value">{{ cat.label }}</option>
                      }
                    </select>
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-label">{{ 'DocumentPage.SigningAuthority' | translate }}</label>
                  <div class="select-wrapper ng-select-wrapper">
                    <ng-select
                      class="field-control ng-select-field single-line-selector create-form-select"
                      [items]="signingAuthorities"
                      bindLabel="label"
                      bindValue="id"
                      [(ngModel)]="signingAuthorityId"
                      [searchable]="true"
                      [clearable]="true"
                      [disabled]="resumeMetadataLocked"
                      appendTo="body"
                      [placeholder]="isLoadingSigningAuthorities ? ('DocumentPage.LoadingSigningAuthorities' | translate) : ('DocumentPage.SelectSigningAuthority' | translate)">
                    </ng-select>
                  </div>
                </div>

                <div class="form-group workflow-share-toggle">
                  <label
                    class="option-toggle"
                    [class.is-checked]="enableWorkflow"
                    [class.is-disabled]="resumeMetadataLocked || !isWorkflowAllowedForUpload">
                    <input
                      type="checkbox"
                      name="enableWorkflow"
                      [ngModel]="enableWorkflow"
                      (ngModelChange)="onEnableWorkflowChange($event)"
                      [disabled]="resumeMetadataLocked || !isWorkflowAllowedForUpload" />
                    <span class="option-toggle-box" aria-hidden="true">
                      <i class="pi pi-check"></i>
                    </span>
                    <span class="option-toggle-copy">
                      <span class="option-toggle-title">{{ 'DocumentPage.EnableWorkflow' | translate }}</span>
                      <span class="option-toggle-hint">{{ 'DocumentPage.EnableWorkflowHint' | translate }}</span>
                    </span>
                  </label>
                  @if (!isWorkflowAllowedForUpload) {
                    <p class="workflow-document-warning" role="status">
                      <i class="pi pi-info-circle" aria-hidden="true"></i>
                      <span>{{ 'DocumentPage.WorkflowDocumentsOnlyWarning' | translate }}</span>
                    </p>
                  }
                </div>

                <div class="form-group workflow-share-toggle">
                  <label class="option-toggle" [class.is-checked]="shareWithRecipients" [class.is-disabled]="resumeMetadataLocked">
                    <input
                      type="checkbox"
                      name="shareWithRecipients"
                      [ngModel]="shareWithRecipients"
                      (ngModelChange)="onShareWithRecipientsChange($event)"
                      [disabled]="resumeMetadataLocked" />
                    <span class="option-toggle-box" aria-hidden="true">
                      <i class="pi pi-check"></i>
                    </span>
                    <span class="option-toggle-copy">
                      <span class="option-toggle-title">{{ 'MEDIALIBRARY.uploadShareWithUsers' | translate }}</span>
                      <span class="option-toggle-hint">{{ 'MEDIALIBRARY.uploadShareWithUsersHint' | translate }}</span>
                    </span>
                  </label>
                </div>

                @if (enableWorkflow && isWorkflowAllowedForUpload) {
                  <div class="form-group" [class.full-width]="!shareWithRecipients">
                    <label class="form-label">{{ 'DocumentPage.Workflow' | translate }}</label>
                    <div class="select-wrapper ng-select-wrapper">
                      <ng-select
                        class="field-control ng-select-field single-line-selector create-form-select"
                        [items]="workflows"
                        bindLabel="label"
                        bindValue="id"
                        [(ngModel)]="workflowId"
                        [searchable]="true"
                        [clearable]="true"
                        [disabled]="resumeMetadataLocked"
                        appendTo="body"
                        [placeholder]="isLoadingWorkflows ? ('DocumentPage.LoadingWorkflows' | translate) : ('DocumentPage.SelectWorkflow' | translate)">
                      </ng-select>
                    </div>
                    <p class="workflow-document-warning workflow-document-warning--compact" role="status">
                      <i class="pi pi-info-circle" aria-hidden="true"></i>
                      <span>{{ 'DocumentPage.WorkflowDocumentsOnlyWarning' | translate }}</span>
                    </p>
                  </div>
                }

                @if (shareWithRecipients) {
                  <div class="form-group" [class.full-width]="!(enableWorkflow && isWorkflowAllowedForUpload)">
                    <label class="form-label">
                      {{ 'DocumentPage.Recipients' | translate }} <span class="text-danger">*</span>
                    </label>
                    <div class="select-wrapper ng-select-wrapper">
                      <ng-select
                        class="ds-multi-select"
                        [items]="shareRecipients"
                        bindLabel="label"
                        bindValue="id"
                        [(ngModel)]="selectedShareRecipientIds"
                        [multiple]="true"
                        [searchable]="true"
                        [clearable]="true"
                        [closeOnSelect]="false"
                        [disabled]="resumeMetadataLocked"
                        appendTo="body"
                        [placeholder]="
                          isLoadingShareRecipients
                            ? ('DocumentPage.Loading' | translate)
                            : !selectedUploadDepartmentId
                              ? ('DocumentPage.SelectDepartmentFirst' | translate)
                              : shareRecipients.length === 0
                                ? ('DocumentPage.NoRecipientsFound' | translate)
                                : ('DocumentPage.SelectRecipients' | translate)
                        ">
                        <ng-template ng-header-tmp>
                          <div class="ds-multi-select-toolbar">
                            <button type="button" class="ds-multi-select-action" (click)="selectAllShareRecipients($event)">{{ 'DocumentPage.SelectAll' | translate }}</button>
                            <button type="button" class="ds-multi-select-action" (click)="clearAllShareRecipients($event)">{{ 'DocumentPage.ClearAll' | translate }}</button>
                            <span class="ds-multi-select-count">{{ selectedShareRecipientIds?.length || 0 }} {{ 'DocumentPage.Selected' | translate }}</span>
                          </div>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                          <div class="ds-multi-option">
                            <span class="ds-multi-option-check" [class.is-selected]="isShareRecipientSelected(item)">
                              <i class="pi pi-check" aria-hidden="true"></i>
                            </span>
                            <span>{{ item.label }}</span>
                          </div>
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                          <div class="ng-value" *ngFor="let item of items | slice:0:2">
                            <span class="ng-value-label">{{ getShareRecipientLabel(item) }}</span>
                            <span class="ng-value-icon right" (click)="clear(item); $event.stopPropagation()" aria-hidden="true">×</span>
                          </div>
                          <div class="ng-value remaining-more-tag" *ngIf="items.length > 2" [attr.title]="getRemainingShareRecipientsTooltip(items, 2)">
                            <span class="ng-value-label">+{{ items.length - 2 }}</span>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                }

                <div class="form-group">
                  <label class="form-label">{{ 'DocumentPage.Date' | translate }}</label>
                  <doc-ngb-datepicker [(ngModel)]="date" [showIcon]="true" [minDate]="today" [placeholder]="'DocumentPage.Date' | translate"
                    containerClass="full-width" [disabled]="resumeMetadataLocked">
                    <span dateIcon>
                      <app-dynamic-icon name="custom:calendar-linear"></app-dynamic-icon>
                    </span>
                  </doc-ngb-datepicker>
                </div>
              }

              @if (folderMetadataEditMode) {
                <div class="form-group">
                  <label class="form-label">{{ 'DocumentPage.Date' | translate }}</label>
                  <doc-ngb-datepicker [(ngModel)]="date" [showIcon]="true" [minDate]="today" [placeholder]="'DocumentPage.Date' | translate"
                    containerClass="full-width" [disabled]="resumeMetadataLocked">
                    <span dateIcon>
                      <app-dynamic-icon name="custom:calendar-linear"></app-dynamic-icon>
                    </span>
                  </doc-ngb-datepicker>
                </div>
              }

              <!-- Location -->
               @if(editMode && envConfig.isLocationSecExpanded) {
              <div class="form-group">
                <label class="form-label">Location <span class="text-danger">*</span></label>
                <div class="select-wrapper ng-select-wrapper">
                  <ng-select
                    class="field-control ng-select-field single-line-selector"
                    [items]="locationSelectItems"
                    bindLabel="locationNameEn"
                    [(ngModel)]="selectedLocation"
                    (ngModelChange)="onLocationModelChange($event)"
                    [searchable]="true"
                    [clearable]="true"
                    [addTag]="addLocationTag"
                    [compareWith]="compareLocations"
                    placeholder="Select or enter Location"
                    appendTo="body"
                    (search)="onLocationSearch($event)">
                    <ng-template ng-option-tmp let-item="item">
                      <div class="d-flex justify-content-between align-items-center">
                        <span>{{ item.locationNameEn }}</span>
                        @if (item.isNew) {
                          <span class="badge badge-info ms-2">New Location</span>
                        }
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            }

              <!-- Row 3: Event and Event date range -->
               @if(editMode && envConfig.isEventsSecExpanded) {
              <div class="form-group form-group--event">
                <label class="form-label">Event <span class="text-danger">*</span></label>
                <div class="select-wrapper ng-select-wrapper">
                  <ng-select
                    class="field-control ng-select-field"
                    [items]="eventSelectItems"
                    bindLabel="eventNameEn"
                    [(ngModel)]="selectedEvent"
                    (ngModelChange)="onEventModelChange($event)"
                    [searchable]="true"
                    [clearable]="true"
                    [addTag]="addEventTag"
                    [compareWith]="compareEvents"
                    [disabled]="resumeMetadataLocked"
                    placeholder="Event"
                    appendTo="body"
                    (search)="onEventSearch($event)">
                    <ng-template ng-option-tmp let-item="item">
                      <div class="d-flex justify-content-between align-items-center" [class.inactive-event-item]="item.isInactive">
                        <span [class.text-muted]="item.isInactive">{{ item.eventNameEn }}</span>
                        @if (item.isNew) {
                          <span class="badge badge-info ms-2">New Event</span>
                        }
                        @if (item.isInactive) {
                          <span class="badge bg-secondary ms-2" style="font-size: 0.7rem;">Inactive</span>
                        }
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>

              <div class="form-group form-group--event-date-range">
                <label class="form-label">{{ 'DocumentPage.EventDateRange' | translate }} <span class="text-danger">*</span></label>
                <div class="date-range-wrapper" [class.is-disabled]="isEventDateRangeLocked" #eventDateRangeWrapper>
                  <doc-ngb-date-range
                    #eventDatePicker
                    [(ngModel)]="eventDateRange"
                    containerClass="event-date-range-calendar"
                    [readonly]="true"
                    [startPlaceholder]="'DASHBOARD.selectStartDate' | translate"
                    [endPlaceholder]="'DASHBOARD.selectEndDate' | translate"
                    [disabled]="isEventDateRangeLocked"
                    (rangeComplete)="onEventDateRangeSelect()">
                  </doc-ngb-date-range>
                  <div class="date-range-actions" aria-hidden="false">
                    @if (eventDateRange?.length && !isEventDateRangeLocked) {
                      <span
                        class="date-clear-icon"
                        (click)="clearDateRange(); $event.stopPropagation()"
                        title="Clear dates"
                        role="button"
                        tabindex="0"
                        (keydown.enter)="clearDateRange()"
                        (keydown.space)="$event.preventDefault(); clearDateRange()">
                        ✕
                      </span>
                    }
                    @if (!isEventDateRangeLocked) {
                      <span
                        class="date-range-icon"
                        (click)="openEventDateRangePicker()"
                        title="Open calendar"
                        role="button"
                        tabindex="0"
                        (keydown.enter)="openEventDateRangePicker()"
                        (keydown.space)="$event.preventDefault(); openEventDateRangePicker()">
                        <app-dynamic-icon name="custom:calendar-linear"></app-dynamic-icon>
                      </span>
                    }
                  </div>
                </div>
              </div>
            }

              <div class="form-group full-width">
                <label class="form-label">
                  {{ 'DocumentPage.Tags' | translate }} <span class="field-label-optional">{{ 'MEDIALIBRARY.uploadTagsOptional' | translate }}</span>
                </label>
                <div class="select-wrapper ng-select-wrapper">
                  <ng-select
                    class="ds-multi-select"
                    [items]="tagSelectItems"
                    bindLabel="tag"
                    [(ngModel)]="tags"
                    (ngModelChange)="onTagsModelChange($event)"
                    [multiple]="true"
                    [searchable]="true"
                    [clearable]="true"
                    [closeOnSelect]="false"
                    [addTag]="addTagFn"
                    [compareWith]="compareTags"
                    [disabled]="resumeMetadataLocked"
                    [placeholder]="'DocumentPage.TagsPlaceholder' | translate"
                    appendTo="body"
                    (search)="onTagSearch($event)">
                    <ng-template ng-header-tmp>
                      <div class="ds-multi-select-toolbar">
                        <button type="button" class="ds-multi-select-action" (click)="selectAllUploadTags($event)">{{ 'DocumentPage.SelectAll' | translate }}</button>
                        <button type="button" class="ds-multi-select-action" (click)="clearAllUploadTags($event)">{{ 'DocumentPage.ClearAll' | translate }}</button>
                        <span class="ds-multi-select-count">{{ tags?.length || 0 }} {{ 'DocumentPage.Selected' | translate }}</span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <div class="ds-multi-option">
                        <span class="ds-multi-option-check" [class.is-selected]="isUploadTagSelected(item)">
                          <i class="pi pi-check" aria-hidden="true"></i>
                        </span>
                        <span>{{ item.tag }}</span>
                        @if (item.isNew) {
                          <span class="badge badge-info ms-2">New</span>
                        }
                      </div>
                    </ng-template>
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                      <div class="ng-value" *ngFor="let item of items | slice:0:2">
                        <span class="ng-value-label">{{ getItemLabel(item) }}</span>
                        <span class="ng-value-icon right" (click)="clear(item); $event.stopPropagation()" aria-hidden="true">×</span>
                      </div>
                      <div class="ng-value remaining-more-tag" *ngIf="items.length > 2" [attr.title]="getRemainingItemsTooltip(items, 2)">
                        <span class="ng-value-label">+{{ items.length - 2 }}</span>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>

              @if (!folderMetadataEditMode) {
                <div class="form-group full-width document-meta-text">
                  <div class="document-meta-line">
                    Document Number - {{ isLoadingDocumentNumbers ? 'Loading…' : (documentNumber || '—') }}
                  </div>
                  <div class="document-meta-line">
                    File Number - {{ isLoadingDocumentNumbers ? 'Loading…' : (fileNumber || '—') }}
                  </div>
                  <div class="document-meta-line">
                    Date (System) : {{ systemDate || '—' }}
                  </div>
                </div>
              }

            </div>

            <doc-ngb-dialog
              [(visible)]="showMetadataLogDialog"
              [modal]="true"
              [draggable]="false"
              [closable]="true"
              [style]="{ width: '46rem', maxWidth: 'calc(100vw - 2rem)' }"
              appendTo="body"
              [baseZIndex]="200080"
              [header]="getMetadataLogDialogHeader()">
              <div class="metadata-log-dialog-content">
                <div class="metadata-details-section">
                  <label class="form-label">More Details</label>
                  <div class="d-flex justify-content-between border-bottom py-2">
                    <span class="text-muted">Created By</span>
                    <span>{{ folderMetadataEditMode ? folderMetaCreatedBy : fileMetaCreatedBy }}</span>
                  </div>
                  <div class="d-flex justify-content-between border-bottom py-2">
                    <span class="text-muted">Created On</span>
                    <span>{{ folderMetadataEditMode ? folderMetaCreatedOn : fileMetaCreatedOn }}</span>
                  </div>
                  <div class="d-flex justify-content-between border-bottom py-2">
                    <span class="text-muted">Last Updated By</span>
                    <span>{{ folderMetadataEditMode ? folderMetaLastUpdatedBy : fileMetaLastUpdatedBy }}</span>
                  </div>
                  <div class="d-flex justify-content-between py-2">
                    <span class="text-muted">Last Updated On</span>
                    <span>{{ folderMetadataEditMode ? folderMetaLastUpdatedOn : fileMetaLastUpdatedOn }}</span>
                  </div>
                  <div class="d-flex justify-content-between border-top py-2 mt-2">
                    <span class="text-muted">Total Views</span>
                    <span>{{ folderMetadataEditMode ? folderMetaTotalViews : fileMetaTotalViews }}</span>
                  </div>
                  <div class="d-flex justify-content-between py-2">
                    <span class="text-muted">Total Downloads</span>
                    <span>{{ folderMetadataEditMode ? folderMetaTotalDownloads : fileMetaTotalDownloads }}</span>
                  </div>
                </div>

                <doc-view-log
                  [entityType]="folderMetadataEditMode ? 'folder' : 'file'"
                  [createdBy]="folderMetadataEditMode ? folderMetaCreatedBy : fileMetaCreatedBy"
                  [createdOn]="folderMetadataEditMode ? folderMetaCreatedOn : fileMetaCreatedOn"
                  [updatedBy]="folderMetadataEditMode ? folderMetaLastUpdatedBy : fileMetaLastUpdatedBy"
                  [updatedOn]="folderMetadataEditMode ? folderMetaLastUpdatedOn : fileMetaLastUpdatedOn"
                  [logs]="mediaActivityLogs">
                </doc-view-log>
              </div>
            </doc-ngb-dialog>

            <!-- Folder Naming Dialog -->
            <doc-ngb-dialog [(visible)]="showNewFolderDialog" [modal]="true" [style]="{width: '400px'}"
              [closable]="true" [draggable]="false" header="Folder Name" styleClass="minimal-naming-dialog"
              appendTo="body" [baseZIndex]="200050">
              <div class="p-4">
                <div class="form-group mb-4">
                  <input type="text" [(ngModel)]="folderNameDraft" placeholder="Folder Name" class="w-full premium-input" [maxlength]="folderNameMaxLength">
                  <div class="text-end text-muted mt-1">{{ (folderNameDraft || '').length }}/{{ folderNameMaxLength }}</div>
                </div>
                <button class="custom-solid-btn w-full" (click)="saveNewFolder()" [disabled]="!folderNameDraft.trim() || isCreatingFolder">Save</button>
              </div>
            </doc-ngb-dialog>

            <!-- Secure Checkbox -->
            <!-- <div class="checkbox-group mb-4" *ngIf="!editMode">
            <input type="checkbox" id="secureCheck" class="checkbox-input" [(ngModel)]="markAsSecure"
              (change)="onSecureChange($event)" [disabled]="resumeMetadataLocked">
              <label for="secureCheck" class="checkbox-label">
                Co-Ownership
              </label>
            </div> -->

            <!-- Share Details - Only show when markAsSecure is checked -->
            @if (markAsSecure && !editMode) {
              <div class="share-section">
                <div class="form-grid share-grid">
                  <!-- Share Type Radio Buttons -->
                  <div class="form-group full-width">
                    <div class="share-type-container">
                      <div class="field-radiobutton">
                        <label class="custom-radio">
                          <input type="radio" name="shareType" value="internal" [(ngModel)]="shareType" (change)="onShareTypeChange()" [disabled]="resumeMetadataLocked">
                          <span class="radio-circle"></span>
                          <span class="radio-label">{{'MEDIALIBRARY.shareFileinternalUseRadio' | translate}} </span>
                        </label>
                      </div>
                      <div class="field-radiobutton">
                        <label class="custom-radio">
                          <input type="radio" name="shareType" value="external" [(ngModel)]="shareType" (change)="onShareTypeChange()" [disabled]="resumeMetadataLocked || shareByDepartment">
                          <span class="radio-circle"></span>
                          <span class="radio-label">{{'MEDIALIBRARY.shareFileexternalUseRadio' | translate}} </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  @if (isDepartmentShareEnabled) {
                    <div class="form-group full-width">
                      <div class="field-checkbox">
                        <doc-custom-checkbox
                          [(ngModel)]="shareByDepartment"
                          [binary]="true"
                          inputId="upload-share-by-department"
                          (onChange)="onShareByDepartmentChange($event.checked)"
                          [disabled]="resumeMetadataLocked">
                        </doc-custom-checkbox>
                        <label for="upload-share-by-department" class="my-2">Share by Department</label>
                      </div>
                    </div>
                  }
                  <!-- Expiry Date -->
                  <div class="form-group">
                    <label class="text-muted text-base">
                      {{ 'MEDIALIBRARY.shareFileExpiryDateLabel' | translate }}
                      <i class="pi pi-info-circle ml-1 cursor-pointer" style="color: #004185;"
                       ngbTooltip="By default no expiry date is set. You can optionally set an expiry date for this item."
                      placement="top"></i>
                    </label>
                    <doc-ngb-datepicker [(ngModel)]="shareExpireDate" [showClear]="true"
                      placeholder="{{ 'MEDIALIBRARY.shareFilePlaceHolderExpiryDate' | translate }}"
                      [showIcon]="true" [minDate]="today" containerClass="full-width custom-calendar"
                      [disabled]="resumeMetadataLocked">
                      <span dateIcon>
                        <app-dynamic-icon name="custom:calendar-linear"></app-dynamic-icon>
                      </span>
                    </doc-ngb-datepicker>
                  </div>
                  @if (envConfig.isSharePermission !== false) {
                    <div class="form-group">
                      <div class="select-wrapper ng-select-wrapper">
                        <ng-select
                          class="ds-multi-select"
                          [items]="uploadPermissionSelectItems"
                          bindLabel="label"
                          bindValue="permissions"
                          [(ngModel)]="sharePermissionLevel"
                          [multiple]="true"
                          [searchable]="true"
                          [clearable]="true"
                          [closeOnSelect]="false"
                          appendTo="body"
                          placeholder="{{ 'MEDIALIBRARY.shareFilePlaceHolderPermissions' | translate }}"
                          (change)="onPermissionChange({ value: $event })"
                          [disabled]="resumeMetadataLocked">
                          <ng-template ng-header-tmp>
                            <div class="ds-multi-select-toolbar">
                              <button type="button" class="ds-multi-select-action" (click)="selectAllUploadPermissions($event)">Select all</button>
                              <button type="button" class="ds-multi-select-action" (click)="clearAllUploadPermissions($event)">Clear all</button>
                              <span class="ds-multi-select-count">{{ sharePermissionLevel?.length || 0 }} selected</span>
                            </div>
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item">
                            <div class="ds-multi-option" [class.disabled-option]="isOptionDisabled(item)">
                              <span class="ds-multi-option-check" [class.is-selected]="isUploadPermissionSelected(item)">
                                <i class="pi pi-check" aria-hidden="true"></i>
                              </span>
                              <span>{{ item.label }}</span>
                            </div>
                          </ng-template>
                          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:2">
                              <span class="ng-value-label">{{ getItemLabel(item) }}</span>
                              <span class="ng-value-icon right" (click)="clear(item); $event.stopPropagation()" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value remaining-more-tag" *ngIf="items.length > 2" [attr.title]="getRemainingItemsTooltip(items, 2)">
                              <span class="ng-value-label">+{{ items.length - 2 }}</span>
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                    </div>
                  }
                  
                  <!-- Department selection only when Share by Department is on -->
                  @if (shareByDepartment) {
                    <div class="form-group">
                      <div class="select-wrapper ng-select-wrapper">
                        <ng-select
                          class="ds-multi-select"
                          [items]="departments"
                          bindLabel="label"
                          bindValue="value"
                          [(ngModel)]="selectedDepartment"
                          [multiple]="true"
                          [searchable]="true"
                          [clearable]="true"
                          [closeOnSelect]="false"
                          appendTo="body"
                          [placeholder]="'MEDIALIBRARY.shareFilePlaceHolderSelectDepartments' | translate"
                          (change)="onDepartmentChange({ value: $event })"
                          [disabled]="resumeMetadataLocked">
                          <ng-template ng-header-tmp>
                            <div class="ds-multi-select-toolbar">
                              <button type="button" class="ds-multi-select-action" (click)="selectAllUploadDepartments($event)">Select all</button>
                              <button type="button" class="ds-multi-select-action" (click)="clearAllUploadDepartments($event)">Clear all</button>
                              <span class="ds-multi-select-count">{{ selectedDepartment?.length || 0 }} selected</span>
                            </div>
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item">
                            <div class="ds-multi-option">
                              <span class="ds-multi-option-check" [class.is-selected]="isUploadDepartmentSelected(item)">
                                <i class="pi pi-check" aria-hidden="true"></i>
                              </span>
                              <span>{{ item.label }}</span>
                            </div>
                          </ng-template>
                          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:2">
                              <span class="ng-value-label">{{ getItemLabel(item) }}</span>
                              <span class="ng-value-icon right" (click)="clear(item); $event.stopPropagation()" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value remaining-more-tag" *ngIf="items.length > 2" [attr.title]="getRemainingItemsTooltip(items, 2)">
                              <span class="ng-value-label">+{{ items.length - 2 }}</span>
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                    </div>
                  }
                  <!-- Users Selection (Only for Internal) -->
                  @if (shareType === 'internal' && !shareByDepartment) {
                    <div class="form-group full-width">
                      <div class="select-wrapper ng-select-wrapper">
                        <ng-select
                          class="ds-multi-select"
                          [items]="uploadUserSelectItems"
                          bindLabel="label"
                          bindValue="value"
                          [(ngModel)]="selectedUsers"
                          [multiple]="true"
                          [searchable]="true"
                          [clearable]="true"
                          [closeOnSelect]="false"
                          appendTo="body"
                          [placeholder]="'MEDIALIBRARY.shareFilePlaceHolderSelectUsers' | translate"
                          [disabled]="resumeMetadataLocked">
                          <ng-template ng-header-tmp>
                            <div class="ds-multi-select-toolbar">
                              <button type="button" class="ds-multi-select-action" (click)="selectAllUploadUsers($event)">Select all</button>
                              <button type="button" class="ds-multi-select-action" (click)="clearAllUploadUsers($event)">Clear all</button>
                              <span class="ds-multi-select-count">{{ selectedUsers?.length || 0 }} selected</span>
                            </div>
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item">
                            <div class="ds-multi-option" [class.disabled-option]="isUserAlreadyShared(item)">
                              <span class="ds-multi-option-check" [class.is-selected]="isUploadUserOptionSelected(item)">
                                <i class="pi pi-check" aria-hidden="true"></i>
                              </span>
                              <span>{{ item.label }}</span>
                            </div>
                          </ng-template>
                          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:2">
                              <span class="ng-value-label">{{ getItemLabel(item) }}</span>
                              <span class="ng-value-icon right" (click)="clear(item); $event.stopPropagation()" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value remaining-more-tag" *ngIf="items.length > 2" [attr.title]="getRemainingItemsTooltip(items, 2)">
                              <span class="ng-value-label">+{{ items.length - 2 }}</span>
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                      @if (users?.length === 0) {
                        <small class="text-muted text-base">No users available</small>
                      }
                    </div>
                  }
                  @if (shareType === 'internal' && !shareByDepartment) {
                    <div class="form-group full-width">
                      <input
                        type="text"
                       
                        [(ngModel)]="internalEmailsText"
                        placeholder="{{ 'MEDIALIBRARY.shareFilePlaceHolderInternalEmails' | translate }}"
                        class="w-full"
                        (blur)="validateInternalEmails()"
                        (input)="validateInternalEmails()"
                        [disabled]="resumeMetadataLocked" />
                        @if (invalidInternalEmails.length > 0) {
                          <div class="text-danger d-block mt-1">
                            <small class="text-base">{{ 'MEDIALIBRARY.shareFileInvalidEmails' | translate }}: {{ invalidInternalEmails.join(', ') }}</small>
                          </div>
                        }
                        @if (nonInternalDomainEmails.length > 0) {
                          <div class="text-danger d-block mt-1">
                            <small class="text-base">{{ 'MEDIALIBRARY.shareFileInternalEmailsNotOrgDomain' | translate }}: {{ nonInternalDomainEmails.join(', ') }}</small>
                          </div>
                        }
                        @if (duplicateInternalEmails.length > 0) {
                          <div class="text-danger d-block mt-1">
                            <small class="text-base">{{ 'MEDIALIBRARY.shareFileDuplicateEmailsInInput' | translate }}: {{ duplicateInternalEmails.join(', ') }}</small>
                          </div>
                        }
                        @if (alreadySharedInternalEmails.length > 0) {
                          <div class="text-danger d-block mt-1">
                            <small class="text-base">{{ 'MEDIALIBRARY.shareFileAlreadySharedEmails' | translate }}: {{ alreadySharedInternalEmails.join(', ') }}</small>
                          </div>
                        }
                      </div>
                    }
                    <!-- External Users Selection (Only for External) -->
                    @if (shareType === 'external' && !shareByDepartment) {
                      <div class="form-group full-width">
                        <div class="select-wrapper ng-select-wrapper">
                          <ng-select
                            class="ds-multi-select"
                            [items]="uploadExternalUserSelectItems"
                            bindLabel="label"
                            bindValue="value"
                            [(ngModel)]="selectedExternalUsers"
                            [multiple]="true"
                            [searchable]="true"
                            [clearable]="true"
                            [closeOnSelect]="false"
                            appendTo="body"
                            [disabled]="resumeMetadataLocked || !externalUsers || externalUsers.length === 0">
                            <ng-template ng-header-tmp>
                              <div class="ds-multi-select-toolbar">
                                <button type="button" class="ds-multi-select-action" (click)="selectAllUploadExternalUsers($event)">Select all</button>
                                <button type="button" class="ds-multi-select-action" (click)="clearAllUploadExternalUsers($event)">Clear all</button>
                                <span class="ds-multi-select-count">{{ selectedExternalUsers?.length || 0 }} selected</span>
                              </div>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                              <div class="ds-multi-option" [class.disabled-option]="isExternalUserAlreadyShared(item)">
                                <span class="ds-multi-option-check" [class.is-selected]="isUploadExternalUserOptionSelected(item)">
                                  <i class="pi pi-check" aria-hidden="true"></i>
                                </span>
                                <span>{{ item.label }}</span>
                              </div>
                            </ng-template>
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                              <div class="ng-value" *ngFor="let item of items | slice:0:2">
                                <span class="ng-value-label">{{ getItemLabel(item) }}</span>
                                <span class="ng-value-icon right" (click)="clear(item); $event.stopPropagation()" aria-hidden="true">×</span>
                              </div>
                              <div class="ng-value remaining-more-tag" *ngIf="items.length > 2" [attr.title]="getRemainingItemsTooltip(items, 2)">
                                <span class="ng-value-label">+{{ items.length - 2 }}</span>
                              </div>
                            </ng-template>
                          </ng-select>
                        </div>
                        @if (externalUsers?.length === 0) {
                          <small>No external users available</small>
                        }
                      </div>
                    }
                    <!-- External Emails (Only for External) -->
                    @if (shareType === 'external' && !shareByDepartment) {
                      <div class="form-group full-width">
                        <input
                          type="text"
                         
                          [(ngModel)]="externalEmailsText"
                          placeholder="{{ 'MEDIALIBRARY.shareFilePlaceHolderExternalEmails' | translate }}"
                          class="w-full"
                          (blur)="validateExternalEmails()"
                          (input)="validateExternalEmails()"
                          [disabled]="resumeMetadataLocked" />
                          @if (invalidExternalEmails.length > 0) {
                            <div class="text-danger d-block mt-1">
                              <small class="text-base">Invalid email(s): {{ invalidExternalEmails.join(', ') }}</small>
                            </div>
                          }
                          @if (duplicateInputEmails.length > 0) {
                            <div class="text-danger d-block mt-1">
                              <small class="text-base">Duplicate email(s) in input: {{ duplicateInputEmails.join(', ') }}</small>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }

                <!-- Resume Notice (above progress bar, after co-ownership) -->
                @if (incompleteSessionCount > 0) {
                  <div class="resume-notice mb-3">
                    <div class="d-flex align-items-start gap-2">
                      <i class="pi pi-info-circle mt-1"></i>
                      <div class="flex-grow-1">
                        <div class="fw-bold">Resume upload to continue</div>
                        <div>
                          Please re-select the original file(s). Any file you re-select will resume from the remaining bytes.
                          Files you do not re-select will remain paused.
                        </div>
                      </div>
                    </div>
                  </div>
                }

                <!-- Active Uploads Indicator (shown when there are active uploads from previous session) -->
                @if (!editMode && activeUploadsCount > 0 && !showResumableUpload) {
                  <div class="active-uploads-indicator mt-3 mb-3 p-3" style="background: #f8f9fa; border-radius: 8px; border: 1px solid #dee2e6;">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <div>
                        <strong><i class="pi pi-cloud-upload mr-2"></i>{{ activeUploadsCount }} Upload(s) in Progress</strong>
                      </div>
                      <small class="text-muted">These uploads are continuing in the background</small>
                    </div>
                    <div class="upload-summary">
                      @for (upload of activeUploads; track upload) {
                        <div class="upload-summary-item mb-2">
                          <div class="d-flex justify-content-between align-items-center">
                            <span class="file-name-text" [title]="upload.fileName">{{ upload.fileName }}</span>
                            <span class="status-badge-small" [ngClass]="'status-' + upload.status">{{ upload.status }}</span>
                          </div>
                          <div class="progress-bar-small mt-1">
                            <div class="progress-fill" [style.width.%]="upload.progress" [ngClass]="'status-' + upload.status"></div>
                          </div>
                          <small class="text-muted">{{ upload.progress.toFixed(1) }}% ({{ formatBytes(upload.bytesUploaded) }} / {{ formatBytes(upload.totalBytes) }})</small>
                        </div>
                      }
                    </div>
                    <div class="mt-2">
                      <small class="text-info">
                        <i class="pi pi-info-circle mr-1"></i>
                        Uploads will continue automatically. You can manage them below when you add new files.
                      </small>
                    </div>
                  </div>
                }

                <!-- Resumable Upload Progress Section (only shown in resumable mode) -->
                @if (!editMode && useResumableUpload && (showResumableUpload || hasUploadsInManager)) {
                  <div class="resumable-upload-progress-section mt-4">
                    <doc-resumable-upload
                      #resumableUpload
                      [files]="selectedFiles"
                      [folderId]="getResolvedFolderId()"
                      [perFileFolderIds]="perFileFolderIds"
                      [folderMetadataOnlyFolderIds]="folderStructureCreatedFolderIdsForUpload"
                      [titleEn]="title"
                      [titleAr]="''"
                      [eventId]="selectedEvent?.eventId"
                      [newEvent]="getNewEventName()"
                      [eventDate]="getResumableEventDateIso()"
                      [eventStartDate]="getResumableEventStartIso()"
                      [eventEndDate]="getResumableEventEndIso()"
                      [locationId]="getResumableLocationId()"
                      [newLocation]="getResumableNewLocation()"
                      [fileCreationDate]="getResumableFileCreationIso()"
                      [tagIds]="getTagIdsArray()"
                      [newTags]="getNewTagsArray()"
                      [isMarkSecure]="markAsSecure"
                      [shareType]="shareType"
                      [shareUserIds]="getMergedShareUserIdsForUpload()"
                      [shareEmails]="getShareEmails()"
                      [shareExpireOn]="getShareExpireOn()"
                      [workflowId]="getEffectiveWorkflowIdForUpload()"
                      [userId]="userId"
                      [autoStart]="false"
                      [autoResume]="true"
                      (uploadStarted)="onResumableUploadStarted()"
                      (uploadComplete)="onResumableUploadComplete($event)"
                      (uploadError)="onResumableUploadError($event)"
                      (allUploadsCompleted)="onAllUploadsCompleted($event)"
                      (fileRemoved)="onFileRemovedFromUpload($event)"
                      (slowInternetDetected)="onSlowInternetDetected()">
                    </doc-resumable-upload>
                  </div>
                }

                <!-- Start New Upload Notice (below progress bar) -->
                @if (!editMode && incompleteSessionCount > 0) {
                  <div class="resume-notice mt-3">
                    <div class="d-flex align-items-start justify-content-between gap-2">
                      <div class="d-flex align-items-start gap-2">
                        <i class="pi pi-info-circle mt-1"></i>
                        <div>
                          If you want to start a new upload instead, clear all resumable sessions.
                        </div>
                      </div>
                      <button type="button" class="custom-outline-btn" (click)="clearResumableSessions()">
                        Clear All
                      </button>
                    </div>
                  </div>
                }
                <!-- Upload Button -->
                <div class="upload-actions">
                  @if (!editMode) {
                    <div class="upload-info-card" aria-hidden="false">
                      <span class="upload-info-icon" aria-hidden="true">
                        <i class="pi pi-folder"></i>
                      </span>
                      <div class="upload-info-text">
                        <span class="upload-info-title">{{ 'MEDIALIBRARY.uploadMultipleFiles' | translate }}</span>
                        <span class="upload-info-sub">{{ 'MEDIALIBRARY.uploadMaxFileSize' | translate: { size: formatBytes(RESUMABLE_UPLOAD_THRESHOLD) } }}</span>
                      </div>
                    </div>
                  } @else {
                    <div class="upload-actions-spacer"></div>
                  }
                  <div class="upload-actions-btns">
                    @if (editMode) {
                      <button
                        type="button"
                        class="ds-btn ds-btn--outline upload-btn-cancel"
                        (click)="showMetadataLogDialog = true">
                        <i class="pi pi-history" aria-hidden="true"></i>
                        {{ 'MEDIALIBRARY.uploadViewLog' | translate }}
                      </button>
                    }
                    @if (!editMode) {
                      <button
                        type="button"
                        class="ds-btn ds-btn--outline upload-btn-cancel"
                        (click)="closeDialog()">
                        <i class="pi pi-times" aria-hidden="true"></i>
                        {{ 'MEDIALIBRARY.uploadCancel' | translate }}
                      </button>
                    }
                    <button
                      type="button"
                      class="ds-btn ds-btn--solid upload-btn-save"
                      (click)="uploadMedia()"
                      [disabled]="!isUploadValid()">
                      <i class="pi pi-save" aria-hidden="true"></i>
                      {{ getUploadButtonText() }}
                    </button>
                  </div>
                </div>

                <!-- Info message when files are selected and approach threshold -->
                @if (selectedFiles.length > 0 && !showResumableUpload) {
                  <div class="mt-3">
                    <small class="text-muted text-base">
                      Total file size: {{ formatBytes(getTotalFileSize()) }}
                      @if (getTotalFileSize() > RESUMABLE_UPLOAD_THRESHOLD * 0.8) {
                        <span class="text-warning">
                          (Approaching 1GB limit)
                        </span>
                      }
                    </small>
                  </div>
                }


              </doc-ngb-dialog>
